<script lang="ts">var _a, _b, _c, _d;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
export let element;
export let sources;
export let sourceStore;
$: {
    sourceStore = getFirstSourceStore($sources);
}
;
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: extraData = (data === null || data === void 0 ? void 0 : data.ExtraData) ? JSON.parse(data.ExtraData) : {};
$: title = (extraData === null || extraData === void 0 ? void 0 : extraData.Title) || `Badge ${(data === null || data === void 0 ? void 0 : data.AchievementID) || ''}`.trim();
$: completed = (data === null || data === void 0 ? void 0 : data.LifetimeCompletions) > 0;
$: imageUrl = (((completed && (extraData === null || extraData === void 0 ? void 0 : extraData.ImageUrl)) || (!completed && extraData.UncompletedImageUrl)) || (element === null || element === void 0 ? void 0 : element.data.defaultBadgeImage)) || '/static/images/badge1.png';
$: fontFace = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.fontFace) || "";
$: activeColor = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.activeColor) || "";
$: inactiveColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.inactiveColor) || "";
$: fontSize = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.fontSize) || "";
</script>

<CardBase {element}>
  <div class="achievement-badge">
    <div class="icon-wrapper" style={`background-image: url(${imageUrl}); background-position: center; background-size: contain;`}>
    </div>
    <label
      class="name"
      style={`font-family: ${fontFace}; font-size: ${fontSize}; color: ${completed ? activeColor : inactiveColor};`}
    >
      {title}
    </label>
  </div>
</CardBase>

<style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.achievement-badge {
  width: 77px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-wrapper {
  width: 77px;
  height: 77px;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.name {
  text-align: center;
}</style>
